<section class="tata-mitra-sec pt-5 pb-5 pt-xl-0">
  <div class="container">
    <div class="content-heading d-flex align-items-center justify-content-between mb-4">
      <h1 class="page-sub-title cv-text-dark">Blogs and Stories</h1>
      <a href="#" class="view-more" [routerLink]="'/blogs-and-stories'" >View more
        <img [src]="environment1 + 'images/new-images/right_Arr.svg'" alt="Arrow" loading="lazy">
      </a>
    </div>
    <div class="row">
      <ng-container *ngIf="tataMitrablogList?.length == 0 || !productLoaded;else productTemplate">
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-2 order-md-1">
          <div class="row g-3">
            <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6"  *ngFor="let item of skeletonService.generateFake(4);let i = index;">
              <div class="row g-2 mitra-news">
                <div class="col-5 col-sm-4 col-md-4 col-lg-12">
                  <div class="image-wrapper">
                    <ngx-skeleton></ngx-skeleton>
                  </div>
                </div>
                <div class="col-7 col-sm-8 col-md-8 col-lg-12">
                  <div class="date-time mb-1">
                    <ngx-skeleton height="15px"></ngx-skeleton>
                  </div>
                  <div class="desc cursor">
                    <ngx-skeleton height="15px"></ngx-skeleton>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-1 order-md-2">
          <div class="mitra-news-large" >
            <div class="image-wrapper">
              <ngx-skeleton></ngx-skeleton>
            </div>
            <div class="date-desc">
              <div class="date-time mb-1">
                <ngx-skeleton height="20px"></ngx-skeleton>
              </div>
              <div class="desc cursor">
                <ngx-skeleton height="20px"></ngx-skeleton>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #productTemplate>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-2 order-md-1">
        <div class="row g-3">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row g-2 mitra-news" [ngClass]="{
              video: tataMitrablogList[0]?.type == 'VIDEOS',
              news: tataMitrablogList[0]?.type == 'NEWS',
              blog: tataMitrablogList[0]?.type == 'BLOG'
            }">
              <div class="col-5 col-sm-4 col-md-4 col-lg-12">
                <div class="image-wrapper">
                  <div  *ngIf="tataMitrablogList[0]?.youtube_url" >

                    <ngx-lite-youtube [videoId]="getURL(tataMitrablogList[0]?.youtube_url)" style="width: 100%"></ngx-lite-youtube>
                  </div>
                  <img alt="Tata mitra" *ngIf="!tataMitrablogList[0]?.youtube_url" src="{{ tataMitrablogList[0]?.image_path }}"
                    class="img-fluid" loading="lazy"/>
                </div>
              </div>
              <div class="col-7 col-sm-8 col-md-8 col-lg-12">
                <div class="date-time mb-1">
                  {{ tataMitrablogList[0]?.created_date | date : "dd/MM/yyyy" }}
                </div>
                <div class="desc cursor">
                  <div  style="color: black; text-decoration: none" [innerHTML]="tataMitrablogList[0]?.title"
                  (click)="redirectTo(tataMitrablogList[0]?.id,tataMitrablogList[0]?.title)">
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row g-2 mitra-news" [ngClass]="{
              video: tataMitrablogList[1]?.type == 'VIDEOS',
              news: tataMitrablogList[1]?.type == 'NEWS',
              blog: tataMitrablogList[1]?.type == 'BLOG'
            }">
              <div class="col-5 col-sm-4 col-md-4 col-lg-12" >
              <div class="image-wrapper">
                <div class="" *ngIf="tataMitrablogList[1]?.youtube_url ">

                  <ngx-lite-youtube [videoId]="getURL(tataMitrablogList[1]?.youtube_url)" style="width: 100%"></ngx-lite-youtube>
                </div>
                <img alt="Tata mitra" *ngIf="!tataMitrablogList[1]?.youtube_url" src="{{ tataMitrablogList[1]?.image_path }}"
                  class="img-fluid" loading="lazy"/>
              </div>
              </div>
              <div class="col-7 col-sm-8 col-md-8 col-lg-12">
                <div class="date-time mb-1">
                  {{ tataMitrablogList[1]?.created_date | date : "dd/MM/yyyy" }}
                </div>
                <div class="desc cursor" >
                  <div style="color: black; text-decoration: none" [innerHTML]="tataMitrablogList[1]?.title"
                  (click)="redirectTo(tataMitrablogList[1]?.id,tataMitrablogList[1]?.title)"></div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row g-2 mitra-news" [ngClass]="{
              video: tataMitrablogList[2]?.type == 'VIDEOS',
              news: tataMitrablogList[2]?.type == 'NEWS',
              blog: tataMitrablogList[2]?.type == 'BLOG'
            }">
              <div class="col-5 col-sm-4 col-md-4  col-lg-12">
                <div class="image-wrapper">

                  <div class="ratio ratio-4x3" *ngIf="tataMitrablogList[2]?.youtube_url ">

                    <ngx-lite-youtube [videoId]="getURL(tataMitrablogList[2]?.youtube_url)" style="width: 100%"></ngx-lite-youtube>
                  </div>
                  <img alt="Tata mitra" *ngIf="!tataMitrablogList[2]?.youtube_url" src="{{ tataMitrablogList[2]?.image_path }}"
                    class="img-fluid" loading="lazy"/>
                </div>
              </div>
              <div class="col-7 col-sm-8 col-md-8  col-lg-12">
                <div class="date-time mb-1">
                  {{ tataMitrablogList[2]?.created_date | date : "dd/MM/yyyy" }}
                </div>
                <div class="desc cursor" >
                  <div style="color: black; text-decoration: none" [innerHTML]="tataMitrablogList[2]?.title"
                  (click)="redirectTo(tataMitrablogList[2]?.id,tataMitrablogList[2]?.title)"></div>
                </div>
              </div>
            </div>

          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
            <div class="row g-2 mitra-news" [ngClass]="{
              video: tataMitrablogList[3]?.type == 'VIDEOS',
              news: tataMitrablogList[3]?.type == 'NEWS',
              blog: tataMitrablogList[3]?.type == 'BLOG'
            }">
              <div class="col-5 col-sm-4 col-md-4  col-lg-12">
                <div class="image-wrapper">

                  <div class="ratio ratio-4x3" *ngIf="tataMitrablogList[3]?.youtube_url ">

                    <ngx-lite-youtube [videoId]="getURL(tataMitrablogList[3]?.youtube_url)" style="width: 100%"></ngx-lite-youtube>
                  </div>
                  <img alt="Tata mitra" *ngIf="!tataMitrablogList[3]?.youtube_url" src="{{ tataMitrablogList[3]?.image_path }}"
                    class="img-fluid" loading="lazy"/>
                </div>
              </div>
              <div class="col-7 col-sm-8 col-md-8  col-lg-12">
                <div class="date-time mb-1">
                  {{ tataMitrablogList[3]?.created_date | date : "dd/MM/yyyy" }}
                </div>
                <div class="desc cursor">
                  <div  style="color: black; text-decoration: none" [innerHTML]="tataMitrablogList[3]?.title"
                  (click)="redirectTo(tataMitrablogList[3]?.id,tataMitrablogList[3]?.title)"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 order-1 order-md-2">
        <div class="mitra-news-large" [ngClass]="{
            video: tataMitrablogList[4]?.type == 'VIDEOS',
            news: tataMitrablogList[4]?.type == 'NEWS',
            blog: tataMitrablogList[4]?.type == 'BLOG'
          }">
          <div class="image-wrapper">
            <div class="ratio ratio-1x1" *ngIf="tataMitrablogList[4]?.youtube_url">

              <ngx-lite-youtube [videoId]="getURL(tataMitrablogList[4]?.youtube_url)" style="width: 100%"></ngx-lite-youtube>
            </div>
            <img alt="Tata mitra" *ngIf="!tataMitrablogList[4]?.youtube_url" src="{{ tataMitrablogList[4]?.image_path }}"
              class="img-fluid" loading="lazy"/>
          </div>
          <div class="date-desc">
            <div class="date-time mb-1">
              {{ tataMitrablogList[4]?.created_date | date : "dd/MM/yyyy" }}
            </div>
            <div class="desc cursor"  >
              <div  style="color: black; text-decoration: none" [innerHTML]="tataMitrablogList[4]?.title"
                (click)="redirectTo(tataMitrablogList[4]?.id,tataMitrablogList[4]?.title)"></div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    </div>
  </div>
</section>
